import { render, staticRenderFns } from "./CustomersPerWeekChart.vue?vue&type=template&id=662e0e20"
import script from "./CustomersPerWeekChart.vue?vue&type=script&lang=js"
export * from "./CustomersPerWeekChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports